import React from 'react';
import { Lock } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import CreateEventDialog from './CreateEventDialog';

interface CreateEventButtonProps {
  onEventCreated: () => void;
}

const CreateEventButton: React.FC<CreateEventButtonProps> = ({ onEventCreated }) => {
  const { isAdmin } = useAuth();

  // Admin can create events
  if (isAdmin) {
    return <CreateEventDialog onEventCreated={onEventCreated} />;
  }

  // Non-admin sees info message
  return (
    <div className="flex items-center gap-2 text-sm text-muted-foreground">
      <Lock className="h-4 w-4" />
      <span>Création réservée aux organisateurs</span>
    </div>
  );
};

export default CreateEventButton;
